var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBadgeRejected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M0-3.375a4.5,4.5,0,0,1,4.5-4.5A4.5,4.5,0,0,1,9-3.375a4.5,4.5,0,0,1-4.5,4.5A4.5,4.5,0,0,1,0-3.375Zm3.076-.842.828.826-.828.842a.406.406,0,0,0,0,.582.382.382,0,0,0,.582,0l.826-.812.842.812a.382.382,0,0,0,.582,0,.382.382,0,0,0,0-.582L5.1-3.391l.812-.826a.382.382,0,0,0,0-.582.406.406,0,0,0-.582,0l-.842.828L3.658-4.8a.406.406,0,0,0-.582,0A.406.406,0,0,0,3.076-4.217Z",
    transform: "translate(0 7.875)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeRejected);
export default __webpack_public_path__ + "static/media/badge-rejected.dcb3706508cc25389a9920a7a3468eee.svg";
export { ForwardRef as ReactComponent };